import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;


function* getPartnerForAccount(actions) {
    let uuid = getSetCookie();
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
            "X-RealmUuid": uuid,
        };

        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null
                ? apiUrl + "/payment/partners"
                : apiUrl + "/payment/partners" + actions.query;

        if (enviromentUrl !== "") {
            if (url.includes("?")) {
                url += `&env=${enviromentUrl}`;
            } else {
                url += `?env=${enviromentUrl}`;
            }
        }

        const response = yield call(apiCall, "get", url, requestOptions);

        yield put({ type: "PARTNER_FOR_ACCOUNT_RESPONSE_GET", value: response });
    }
    catch (error) {
        yield put({
            type: "SET_ERROR",
            payload: { responseStatus: error.message },
        });
    }
}

function* getPaymentProfiles(actions) {
    let uuid = getSetCookie();

    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
            "X-RealmUuid": uuid,
        };

        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null
                ? apiUrl + "/payment/profiles"
                : apiUrl + "/payment/profiles" + actions.query;

        if (enviromentUrl !== "") {
            if (url.includes("?")) {
                url += `&env=${enviromentUrl}`;
            } else {
                url += `?env=${enviromentUrl}`;
            }
        }

        const response = yield call(apiCall, "get", url, requestOptions);

        yield put({ type: "PAYMENTPROFILE_RESPONSE_GET", value: response });
    }
    catch (error) {
        yield put({
            type: "SET_ERROR",
            payload: { responseStatus: error.message },
        });
    }
}

function* getPaymentRules(actions) {
    let uuid = getSetCookie();

    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
            "X-RealmUuid": uuid,
        };

        const requestOptions = {
            headers: headers,
        };

       let url = `${apiUrl}/payment/rules${actions.query || ""}`;


        if (enviromentUrl !== "") {
            if (url.includes("?")) {
                url += `&env=${enviromentUrl}`;
            } else {
                url += `?env=${enviromentUrl}`;
            }
        }

        const response = yield call(apiCall, "get", url, requestOptions);

        yield put({ type: "PAYMENTRULE_RESPONSE_GET", value: response });
    }
    catch (error) {
        yield put({
            type: "SET_ERROR",
            payload: { responseStatus: error.message },
        });
    }
}

function* createPaymentRule(actions) {
    let uuid = getSetCookie();
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
            "X-RealmUuid": uuid,
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.form),
        };

        let url = apiUrl + "/payment/rules";

        if (enviromentUrl !== "") {
            if (url.includes("?")) {
                url += `&env=${enviromentUrl}`;
            } else {
                url += `?env=${enviromentUrl}`;
            }
        }

        const response = yield call(apiCall, "POST", url, requestOptions);

        if (response.status === "success") {
            yield put({
                type: "PAYMENTRULE_RESPONSE_CREATE",
                payload: { responseStatus: response.status },
            });
        }
        else {
            yield put({
                type: "PAYMENTRULE_RESPONSE_CREATE",
                payload: { responseStatus: response.status },
            });
        }

    }
    catch (error) {
        yield put({
            type: "PAYMENTRULE_RESPONSE_CREATE",
            payload: { responseStatus: error.message },
        });
    }

}

function* updatePaymentRule(actions) {
    let uuid = getSetCookie();
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
            "X-RealmUuid": uuid,
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.form),
        };

        let url = apiUrl + "/payment/rules/" + actions.id;

        if (enviromentUrl !== "") {
            if (url.includes("?")) {
                url += `&env=${enviromentUrl}`;
            } else {
                url += `?env=${enviromentUrl}`;
            }
        }

        const response = yield call(apiCall, "PATCH", url, requestOptions);

        if (response.status === "success") {
            yield put({
                type: "PAYMENTRULE_RESPONSE_UPDATE",
                payload: { responseStatus: response.status },
            });
        }
        else {
            yield put({
                type: "PAYMENTRULE_RESPONSE_UPDATE",
                payload: { responseStatus: response.status },
            });
        }
    } catch (error) {
        yield put({
            type: "PAYMENTRULE_RESPONSE_UPDATE",
            payload: { responseStatus: error.message },
        });
    }
}

function* deletePaymentRule(actions) {
    let uuid = getSetCookie();
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
            "X-RealmUuid": uuid,
        };

        const requestOptions = {
            headers: headers
        };

        let url = apiUrl + "/payment/rules/" + actions.id;

        if (enviromentUrl !== "") {
            if (url.includes("?")) {
                url += `&env=${enviromentUrl}`;
            } else {
                url += `?env=${enviromentUrl}`;
            }
        }

        const response = yield call(apiCall, "DELETE", url, requestOptions);

        if (response.status === 204 || response.status === 200) {
            yield put({
                type: "PAYMENTRULE_RESPONSE_DELETE",
                payload: { status: response.status, responseStatus: "success" },
            });

            yield put({
                type: "GET_PAYMENT_RULES",
                access: actions.access,
                params: actions.query,
            });
        }
        else {

            yield put({
                type: "PAYMENTRULE_RESPONSE_DELETE",
                payload: { responseStatus: response.status },
            });

            yield put({
                type: "GET_PAYMENT_RULES",
                access: actions.access,
                params: actions.query,
            });
        }
    }
    catch (error) {
        yield put({
            type: "PAYMENTRULE_RESPONSE_DELETE",
            payload: { responseStatus: error.message },
        });
    }
}

function* resetPaymentRuleResponse() {
    yield put({ type: "RESET_PAYMENT_RULE_RESPONSE" });
}

function* resetPaymentRuleErrorResponse() {
    yield put({ type: "RESET_ERROR" });
}



export function* getSagaPaymentProfiles() {
    yield takeEvery("GET_PAYMENT_PROFILES", getPaymentProfiles);
}

export function* createSagaPaymentRule() {
    yield takeEvery("CREATE_PAYMENT_RULE", createPaymentRule);
}

export function* getSagaPaymentRules() {
    yield takeEvery("GET_PAYMENT_RULES", getPaymentRules);
}

export function* updateSagaPaymentRule() {
    yield takeEvery("UPDATE_PAYMENT_RULE", updatePaymentRule);
}

export function* deleteSagaPaymentRule() {
    yield takeEvery("DELETE_PAYMENT_RULE", deletePaymentRule);
}

export function* resetSagaPaymentRule() {
    yield takeEvery("RESET_PAYMENT_RULE", resetPaymentRuleResponse);
}

export function* resetSagaErrorPaymentRule() {
    yield takeEvery("RESET_ERROR_PAYMENT_RULE", resetPaymentRuleErrorResponse);
}

export function* getSagaPartnerForAccount() {
    yield takeEvery("GET_PARTNER_FOR_ACCOUNT", getPartnerForAccount);
}

const getSetCookie = () => {
    return window.localStorage.getItem("uuidSetCookie");
};